import React from "react";
import "./style.scss";
import { Col, Row } from "antd";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { photos } from "../photos";

class GalleryItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      mouseOver: false,
    };
    // Bind properties to class instance
    this._clickHandler = this._clickHandler.bind(this);
    this._mouseEnter = this._mouseEnter.bind(this);
    this._mouseLeave = this._mouseLeave.bind(this);
  }
  // Event handlers to modify state values
  _mouseEnter(e) {
    e.preventDefault();
    if (this.state.mouseOver === false) {
      console.log("mouse enter", this.props.data.name);
      this.setState({
        mouseOver: true,
      });
    }
  }
  _mouseLeave(e) {
    e.preventDefault();
    if (this.state.mouseOver === true) {
      this.setState({
        mouseOver: false,
      });
    }
  }
  _clickHandler(e) {
    e.preventDefault();
    console.log("mouse click");
    this.props.onClick(this.props.data);
    if (this.state.open === false) {
      this.setState({
        open: true,
      });
    } else {
      this.setState({
        open: false,
      });
    }
  }

  render() {
    // Modify styles based on state values
    let tileStyle = {};
    let imgStyle = {};
    // When tile clicked
    if (this.state.open) {
      tileStyle = {
        width: "62vw",
        height: "62vw",
        position: "absolute",
        top: "50%",
        left: "50%",
        margin: "0",
        marginTop: "-31vw",
        marginLeft: "-31vw",
        boxShadow: "0 0 40px 5px rgba(0, 0, 0, 0.3)",
        transform: "none",
      };
    } else {
      tileStyle = {
        width: "18vw",
        height: "18vw",
      };
    }

    return (
      <div
        style={{
          width: "100px",
          margin: 3,
          padding: 3,
          backgroundColor: "#ffffff",
          alignSelf: "center",
          flexShrink: 5,
        }}
      >
        <img
          // onMouseEnter={this._mouseEnter}
          // onMouseLeave={this._mouseLeave}
          onClick={this._clickHandler}
          src={this.props.data.thumbnail}
          alt={this.props.data.name}
          style={{
            maxWidth: "100%",
            height: "auto",
            cursor: this.props.lightbox ? "pointer" : null,
          }}
        />
      </div>
    );
  }
}

class Gallery extends React.Component {
  state = {
    photoIndex: 0,
    isOpen: false,
  };

  constructor(props) {
    super(props);

  }

  onClickImg = (item) => {
    if (this.props.lightbox) {
      const index = this.props.data.indexOf(item);
      this.setState({
        photoIndex: index,
        isOpen: true,
      });
    }
  };

  render() {
    const { photoIndex } = this.state;
    const images = () => {
      let items = [];
      this.props.data.map((item, index) => {
        return items.push(item.image);
      });
      return items;
    };
    // console.info("items", this.props.data);
    return (
      <React.Fragment>
        <div>
          {this.props.data ? (
            <React.Fragment>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  backgroundColor: "#222222",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  alignItems: "flext-start",
                }}
              >
                {this.props.data.map((item, index) => {
                  return (
                    <GalleryItem
                      style={{
                        cursor: "pointer",
                      }}
                      data={item}
                      key={index}
                      lightbox={this.props.lightbox}
                      onClick={this.onClickImg}
                    />
                  );
                })}
              </div>
            </React.Fragment>
          ) : null}
        </div>
        {this.state.isOpen && this.props.lightbox ? (
          <Lightbox
            mainSrc={images()[photoIndex]}
            nextSrc={images()[(photoIndex + 1) % images().length]}
            prevSrc={
              images()[(photoIndex + images().length - 1) % images().length]
            }
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex:
                  (photoIndex + images().length - 1) % images().length,
              })
            }
            onMoveNextRequest={() => {
              this.setState({
                photoIndex: (photoIndex + 1) % images().length,
              });
            }}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
export default Gallery;
